import React, { useEffect, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import './payments.css'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import PaymentsService from '../../services/payments.service'
import Data from 'custom/assets/payments/Data.svg'
import CashIn from 'custom/assets/payments/Cash_In.svg'
import CashOut from 'custom/assets/payments/Cash_Out.svg'
import TopUp from 'custom/assets/payments/Top_Up.svg'
import SchoolPayment from 'custom/assets/payments/School_Payments.svg'
import DTHIcon from 'custom/assets/payments/DTH.svg'
import ElectricityIcon from 'custom/assets/payments/electricity.svg'
import InternetIcon from 'custom/assets/payments/Internet.svg'
import WaterIcon from 'custom/assets/payments/water.svg'
import InsuranceIcon from 'custom/assets/payments/Insurance.svg'
import TravelIcon from 'custom/assets/payments/Travel.svg'
import TaxIcon from 'custom/assets/payments/Tax.svg'
import SubscriptionIcon from 'custom/assets/payments/subscription.svg'



const ICONS = {
  DATA: Data,
  CASHIN: CashIn,
  CASHOUT: CashOut,
  TOPUP: TopUp,
  SCHOOLPAY: SchoolPayment,
  DTH: DTHIcon,
  WATER: WaterIcon,
  ELECTRICITY: ElectricityIcon,
  INTERNET: InternetIcon,
  INSURANCE:InsuranceIcon,
  TAX:TaxIcon,
  TRAVEL:TravelIcon,
  SUBSCRIPTION:SubscriptionIcon
}

export default function PayBills() {
  const history = useHistory()
  const [billerList, setBillerList] = useState([])

  useEffect(() => {
    getBillProducts()
  }, [])

  //   const getBillProducts = useCallback(async () => {
  //     try {
  //       const response = await PaymentsService.getAllBillers({
  //         fetchServices: false,
  //         fetchProducts: false,
  //       })
  //       if (response.status === 200) {
  //         response.data['categories'].forEach((element) => {
  //           element.title = element.category
  //           element.desc = element.description
  //           element.icon = ICONS[element.category] || null
  //           element.key = element.category
  //         })
  //         setBillerList(response.data['categories'])
  //       }
  //     } catch (err) {

  //     }
  //   }, [])

  const getBillProducts = useCallback(async () => {
    try {
      const response = await PaymentsService.getAllBillers({
        fetchServices: false,
        fetchProducts: false,
        module: 'PAYMENT',
      })
      if (response.status === 200) {
        response.data['categories'].forEach((element) => {
          element.title = element.category
          element.desc = element.description
          element.icon = ICONS[element.category]
          element.key = element.category
        })
        setBillerList(response.data['categories'])
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  return (
    <LayoutWithAccountCard breadCumKey='PAY_BILLS'>
      <Row>
        {billerList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() =>
              history.push({
                pathname: '/payments/servicesView',
                state: { categoryDetails: option },
              })
            }>
            <img width={52} height={40} src={option?.icon} />
            <h2>{option?.desc}</h2>
          </Col>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
